import React, {  useState } from "react";
import { Footer } from "@components";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { post } from "@utils/axios_api";
import { Input } from "@components/form";
import Modal from "react-modal";

const FindId = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    const validationSchema = Yup.object().shape({
        memberNm: Yup.string().required("이름을 입력해주세요."),
        birthDt: Yup.string()
          .required("생년월일을 입력해주세요.")
          .matches(
            /^\d{4}-\d{2}-\d{2}$/,
            "생년월일은 YYYY-MM-DD 형식이어야 합니다."
          ),
      });

      const methods = useForm({
        resolver: yupResolver(validationSchema),
      });

      const {handleSubmit,reset} = methods;

      const onSubmit = async (data) => {
        setModalMessage("");
        setIsSuccess(false);
        try {
          const response = await post("/member/findId", data);
          if (response.status) {
            setModalMessage(
              response.result && response.result.memberId
                ? `찾으시는 아이디는 ${response.result.memberId} 입니다.`
                : response.message
            );
            setIsSuccess(true);
            reset();
          } else {
            setModalMessage(response.message);
            setIsSuccess(false);
          }
          setModalIsOpen(true);
        } catch (error) {
          console.error(error);
          if (error.response && error.response.data && error.response.data.message) {
            setModalMessage(error.response.data.message);
          } else {
            setModalMessage("예상치 못한 오류가 발생했습니다.");
          }
          setIsSuccess(false);
          setModalIsOpen(true);
        }
      };

      const onError = (errors) => {
        console.log(errors);
      };

      const closeModal = () => {
        setModalIsOpen(false);
      };

  return (
    <FormProvider {...methods}>
    <main id="main" className="mainpage">
      <div>
        <div className="section main-contact">
          <div className="sub-tit-bg">
            <div className="container sub-h">
              <div className="sub-tit-01">
                <img src="/img/ico-home.png" alt="home" />
                아이디 찾기
              </div>
            </div>
          </div>

          <div className="sub-container">
            <div className="sub-layout">
              <div className="sub-contact">
                <h3>아이디 찾기</h3>
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                  <div className="lineTop_tb01" >
                    <table className="lineTop_tb2 table-td-left point">
                    <colgroup>
                      <col style={{ width: '150px' }} />
                      <col />
                      <col style={{ width: '150px' }} />
                      <col />
                    </colgroup>
                    <thead></thead>
                      <tbody>
                        <tr>
                          <th>이름</th>
                          <td style={{padding: '30px 10px'}}>
                            <Input
                              name="memberNm"
                              placeholder="이름을 입력하세요"
                              className="inp-sel-sub"
                            />
                          </td>
                          <th>생년월일</th>
                          <td style={{padding: '30px 10px'}}>
                            <Input
                              name="birthDt"
                              placeholder="YYYY-MM-DD"
                              className="inp-sel-sub"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="text-cent">
                    <button
                      type="submit"
                      className="btn btn-blue mt30 btn-big"
                    >
                      아이디 찾기
                    </button>
                  </div>
                </form>

              </div>
            </div>
          </div>
          <div style={{marginBottom:'141px'}}></div>
          <Footer />
        </div>
      </div>
    </main>

    <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Find ID Modal"
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          content: {
            position: "relative",
            inset: "auto",
            padding: "20px",
            maxWidth: "500px",
            width: "90%",
            borderRadius: "8px",
            boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
          },
        }}
      >
        <div style={{fontSize:'20px'}}>{modalMessage}</div>
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <button
            onClick={closeModal}
            style={{
              padding: "10px 20px",
              backgroundColor: isSuccess ? "#4CAF50" : "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            닫기
          </button>
        </div>
      </Modal>



    </FormProvider>

  );
};

export default FindId;
